// extracted by mini-css-extract-plugin
export default {"mainFooterListItem":"MainFooterListItem_mainFooterListItem__NdkrC","mainFooterLink":"MainFooterListItem_mainFooterLink__3xECy"};